<template>
  <es-dialog :title="$t(`收货地址`)" class="dialog" width="720px" :visible.sync="visible" v-if="visible" :before-close="close" border>
    <es-form :model="form" class="demo-form-inline" label-width="87px" label-position="left" :rules="rules" ref="ruleForm">
      <es-form-item :label="$t(`地址信息：`)" prop="address">
        <es-cascader
          :options="cascaderData"
          :props="props"
          v-model="form.address"
          @active-item-change="handleItemChange"
          style="width: 100%"></es-cascader>
      </es-form-item>
      <es-form-item :label="$t(`详细信息：`)" prop="DetailedAddress">
        <es-input v-model="form.DetailedAddress" :placeholder="$t(`请输入详细地址`)"></es-input>
        <br />
      </es-form-item>
      <es-form-item :label="$t(`收货人：`)" prop="user">
        <es-input v-model="form.user" :placeholder="$t(`请输入收货人`)"></es-input>
      </es-form-item>
      <es-form-item :label="$t(`联系电话：`)" prop="phone">
        <es-input v-model="form.phone" :placeholder="$t(`请输入联系电话`)" maxlength="24"></es-input>
      </es-form-item>
    </es-form>
    <span slot="footer">
      <es-button variant="outline" @click="close">{{ $t('取消') }}</es-button>
      <es-button type="primary" @click="onSubmit">{{ $t('确定') }}</es-button>
    </span>
  </es-dialog>
</template>
<script>
import { $t } from '@/locales'

export default {
  name: 'AddAddressDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        user: '',
        phone: '',
        address: '',
        DetailedAddress: '',
      },
      props: {
        value: 'addressCode',
        label: 'address',
        children: 'cities',
      },
      cascaderData: [],
      rules: {
        user: [
          { max: 50, message: $t('长度不可以超过50个字符'), trigger: 'blur' },
          { required: true, message: $t('请输入收货人'), trigger: 'blur' },
        ],

        phone: [
          { required: true, message: $t('请输入联系电话'), trigger: 'blur' },
          { max: 20, message: $t('长度不可以超过20个字符'), trigger: 'blur' },
        ],

        address: [{ required: true, message: $t('请选择地址'), trigger: 'blur' }],
        DetailedAddress: [
          { required: true, message: $t('请输入详细地址'), trigger: 'blur' },
          { max: 100, message: $t('长度不可以超过100个字符'), trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.openDialog()
  },
  methods: {
    openDialog(val) {
      this.getNodes()
      this.form.address = []
      this.form.user = ''
      this.form.phone = ''
      this.form.DetailedAddress = ''
      this.dialogVisible = true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const data = {
            contact: this.form.user,
            contactNumber: this.form.phone,
            province: this.form.address[0],
            city: this.form.address[1],
            area: this.form.address[2],
            addressDetail: this.form.DetailedAddress,
            defaultFlag: this.form.defaultFlag,
          }
          this.$ajax(this.$url.addAddress(), {
            ...data,
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success',
            })
            this.$emit('submit', res.data.addressId)
            this.dialogVisible = false
          })
        }
      })
    },
    handleItemChange(val) {
      this.getNodes(val)
    },
    getNodes(val) {
      // 选择省市区
      let idArea
      let sizeArea
      if (!val) {
        idArea = null
        sizeArea = 0
      } else if (val.length === 1) {
        idArea = val[0]
        sizeArea = val.length
      } else if (val.length === 2) {
        idArea = val[1]
        sizeArea = val.length
      }
      this.$ajax(this.$url.getAddress(), {
        addressCode: idArea,
      }).then(response => {
        const Items = response.data.addressTags
        if (sizeArea === 0) {
          this.cascaderData = Items.map((value, i) => ({
            addressCode: value.addressCode,
            address: value.address,
            cities: [],
          }))
        } else if (sizeArea === 1) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              if (!pro.cities.length) {
                pro.cities = Items.map(city => ({
                  addressCode: city.addressCode,
                  address: city.address,
                  cities: [],
                }))
              }
            }
          })
        } else if (sizeArea === 2) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              pro.cities.forEach(city => {
                if (city.addressCode === val[1]) {
                  if (!city.cities.length) {
                    city.cities = Items.map(value => ({
                      addressCode: value.addressCode,
                      address: value.address,
                    }))
                  }
                }
              })
            }
          })
        }
      })
    },
    close() {
      this.$emit('close', false)
    },
  },
}
</script>
<style lang="less" scoped>
.demo-form-inline {
  width: 100%;
  margin: 0 auto;
  /deep/ .es-form-item__label {
    padding-right: 0;
  }
}
// .dialog {
//   overflow: hidden;
//   &-footer {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     &-btn {
//       cursor: pointer;
//       width: 80px;
//       height: 30px;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       font-size: 12px;
//       margin: 0 10px 20px 10px;
//       &:nth-child(1) {
//         background: #0975e0ff;
//         color: white;
//       }
//       &:nth-child(2) {
//         background: #e4e4e4;
//         color: #727272;
//       }
//     }
//   }
// }
</style>
